import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SignOffMachine } from '@data-terminal/shared-models/machine';
import { AssistantsSignOff } from '@data-terminal/shared-models/dialogs/sign-off-dialog';

@Component({
    selector: 'data-terminal-sign-off-summary-card',
    templateUrl: './sign-off-summary-card.component.html',
    styleUrls: ['./sign-off-summary-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SignOffSummaryCardComponent {
    @Input() public signOffMachine!: SignOffMachine;
    public STAY = AssistantsSignOff.STAY;
    public LEAVE = AssistantsSignOff.LEAVE;

    public getNewCaptainName(newCaptain: string): string {
        const user = this.signOffMachine.machine.signedOnUsers.find((el) => el.userId === newCaptain);
        return user?.userId || '';
    }
}

@NgModule({
    declarations: [SignOffSummaryCardComponent],
    exports: [SignOffSummaryCardComponent],
    imports: [MatCardModule, CommonModule, TranslateModule],
})
export class SignOffSummaryCardModule {}
